import React from 'react';
import { QueueContent } from './QueueContent';

export const QueuePage: React.FC = React.memo(() => {
    return <QueueContent />;
});
